import type { JSX } from 'react';
import { getSizeInPx } from 'stylesheet';

import { SvgIcon } from './SvgIcon';
import { IconProps } from './types';

export const ProfileIcon = ({ widthInPx, heightInPx, color: _color }: IconProps): JSX.Element => (
  <SvgIcon
    viewBox="0 0 16 16"
    style={{
      width: getSizeInPx(widthInPx ?? 34),
      height: getSizeInPx(heightInPx ?? 34),
      fontWeight: 'bold',
    }}
  >
    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
    <path
      fillRule="evenodd"
      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
    />
  </SvgIcon>
);
